import { render, staticRenderFns } from "./ChartPlaceholder.vue?vue&type=template&id=47abc17f&scoped=true&"
import script from "./ChartPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ChartPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ChartPlaceholder.vue?vue&type=style&index=0&id=47abc17f&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47abc17f",
  null
  
)

export default component.exports